// extracted by mini-css-extract-plugin
export var actions = "_2c-0";
export var actionsContainer = "_2c-7";
export var border = "_2c-1";
export var childFullHeight = "_2c-f";
export var collapse = "_2c-2";
export var content = "_2c-a";
export var contentChild = "_2c-e";
export var fullscreen = "_2c-c";
export var hasLeftRadius = "_2c-k";
export var headerContainer = "_2c-3";
export var headerRow = "_2c-5";
export var hidePadding = "_2c-b";
export var navCollapsedGap = "_2c-l";
export var noScrollX = "_2c-m";
export var noScrollY = "_2c-n";
export var noTopPadding = "_2c-i";
export var optOutTopPadding = "_2c-d";
export var pageMain = "_2c-j";
export var pageOuter = "_2c-g";
export var pagePadding = "_2c-8";
export var pageScroll = "_2c-9";
export var profile = "_2c-o";
export var profileContainer = "_2c-p";
export var profileImage = "_2c-q";
export var profileMain = "_2c-r";
export var profileSubtitle = "_2c-t";
export var profileTitle = "_2c-s";
export var showLeftPadding = "_2c-h";
export var tabsPortalSlot = "_2c-6";
export var tabsWrapper = "_2c-4";
export var title = "_2c-u";